module.exports = __webpack_public_path__ + "static/media/2.e181134d.jpg";